import { z } from "zod";

export const PermitRootTypes = ["Conceptual", "Construction", "Modification", "Uncategorized"] as const;
export const PermitRootTypeSchema = z.enum(PermitRootTypes);
export type PermitRootType = z.infer<typeof PermitRootTypeSchema>;

export const PermitConstructionSubTypes = ["General", "Individual", "Notice"] as const;
export const PermitModificationSubTypes = ["Exempt", "Modification"] as const;
export const PermitSubTypes = [...PermitConstructionSubTypes, ...PermitModificationSubTypes] as const;
export const PermitSubTypeSchema = z.enum(PermitSubTypes);
export type PermitSubType = z.infer<typeof PermitSubTypeSchema>;

export const PermitTypeSchema = z.union([PermitRootTypeSchema, PermitSubTypeSchema]);

export type PermitType = z.infer<typeof PermitTypeSchema>;
